import { TweenMax } from 'gsap';

const getIndex = el => Array.from(el.parentNode.children).indexOf(el);

export default {
  css: false,
  enter(el, index, onComplete) {
    const delay = getIndex(el) * 0.3;
    TweenMax.fromTo(el, 0.3, { autoAlpha: 0 }, { autoAlpha: 1, delay, onComplete });
  }
};
